@if (stakingWidgetUiState$ | async; as model) {
  @if (model.stakeable; as stakeable) {
    <!-- Already staking -->
    @if (showRewardWidget(model.widgetAvailability, stakeable)) {
      <app-staking-widget-reward
        (openModalFlow)="checkFlowAvailability($event)"
        (openRewardsFlow)="openRewardModal($event)">
      </app-staking-widget-reward>
    } @else {
      @if (model.widgetAvailability.isEnabled) {
        <app-staking-widget
          (openModalFlow)="checkFlowAvailability($event)"
          [stakeableName]="stakeable.name">
        </app-staking-widget>
      }
      @if (model.widgetAvailability.isSoldOut) {
        <app-staking-widget-sold-out [stakeableName]="stakeable.name">
        </app-staking-widget-sold-out>
      }
    }
    <!--- Not staking yet -->
  }
}
